import { useContext, useMemo } from 'react';
import { countryToISO } from 'vopay';
import { ClientAccountListHostProps } from 'shared/clientAccountList';
import AccountContext from '@/components/Entities/Accounts/AccountContext';

/**
 * The one place partner-dashboard maps its account model onto what the shared Client Account List
 * takes as props (ID-13352). Mounted by the account page's Client Accounts tab, scoped to one account
 * through that account's own bearer. Mirrors client-dashboard's useClientAccountListHostProps, minus a
 * detail page: a client account's own detail is a non-goal of this milestone (spec §4 Non-Goals 5 —
 * "counts and drill-in only"), so no `accountDetail` is supplied and the list renders each name as text.
 */
export default function useAccountClientAccountsHostProps(accountId: string): ClientAccountListHostProps {
  const { details } = useContext(AccountContext);

  // The listing sends the country as its display name; the list keys its default currency on ISO.
  const country = countryToISO(details[accountId]?.address.country ?? '');

  return useMemo(
    () => ({
      account: { country },
      hostPaths: {},
    }),
    [accountId, country],
  );
}
